import React, {createContext, useContext, ReactNode} from 'react'

interface PlantUpmIdAdapterProps {
  plantUpmId: string
  children: ReactNode
}

interface PlantContextValue {
  plantUpmId: string
}

const PlantUpmIdContext = createContext<PlantContextValue | undefined>(undefined)

// This is adapter context just for the transition period to feature based hproduce suite
// after that we can read the hierrachyId directly from search params
export const PlantUpmIdAdapter: React.FC<PlantUpmIdAdapterProps> = ({plantUpmId, children}) => {
  return <PlantUpmIdContext.Provider value={{plantUpmId}}>{children}</PlantUpmIdContext.Provider>
}

export const usePlantUpmId = (): string => {
  const context = useContext(PlantUpmIdContext)

  if (context === undefined) {
    throw new Error('usePlantUpmId must be used within a PlantUpmIdProvider')
  }

  return context.plantUpmId
}
